import { render, staticRenderFns } from "./CreateMaterialVariantsOrder.vue?vue&type=template&id=71760181&scoped=true"
import script from "./CreateMaterialVariantsOrder.vue?vue&type=script&lang=js"
export * from "./CreateMaterialVariantsOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateMaterialVariantsOrder.vue?vue&type=style&index=0&id=71760181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71760181",
  null
  
)

export default component.exports